export default function Header({ title, children, brand }) {
  return (
    <div className="mb-2 flex items-center justify-between">
      <h3 className="text-base sm:text-lg font-semibold" style={{ color: brand.darkBlue }}>{title}</h3>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}